import { render, staticRenderFns } from "./EmrOpdPtNote.vue?vue&type=template&id=4094898a&"
import script from "./EmrOpdPtNote.vue?vue&type=script&lang=js&"
export * from "./EmrOpdPtNote.vue?vue&type=script&lang=js&"
import style0 from "./EmrOpdPtNote.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports